export default __webpack_public_path__ + "static/callout_personal_3_img_4-c05c8e1e2711119145a1f67f06ecafa4.png";